export const translations = {
  "Show me around": "საიტის გაცნობა",
  Help: "დახმარება",
  "Preview studio": "ნიმუშების სტუდია",
  "Open preview studio": "ნიმუშების სტუდიის გახსნა",
  "Choose a font": "აირჩიეთ შრიფტი",
  "Previous font": "წინა შრიფტი",
  "Next font": "შემდეგი შრიფტი",
  "Sample previews": "გამოყენების ნიმუშები",
  "YOUR FONT COLLECTION": "თქვენი შრიფტების ნაკრები",
  "See it. Make it yours.": "ნახეთ და მოარგეთ თქვენს იდეას.",
  "Preview text": "სანიმუშო ტექსტი",
  Size: "ზომა",
  "Type something in Georgian…": "ჩაწერეთ ტექსტი ქართულად…",
  "Add another font": "სხვა შრიფტის დამატება",
  "FROM PREVIEW TO PRODUCTION": "ნიმუშიდან თქვენს ვებსაიტამდე",
  "On your website.": "თქვენს ვებსაიტზე.",
  "Connect your fonts": "დააკავშირეთ შრიფტები",
  "One link for your entire selection.": "ერთი ბმული მთელი ნაკრებისთვის.",
  "Code format": "კოდის ფორმატი",
  "Give your text a voice": "აამეტყველეთ თქვენი ტექსტი",
  "Apply the font in your stylesheet.": "გამოიყენეთ შრიფტი სტილის ფაილში.",
  "Made for the web": "შექმნილია ვებისთვის",
  "Lightweight WOFF2 files. Text stays visible while fonts load.":
    "მსუბუქი WOFF2 ფაილები. შრიფტის ჩატვირთვამდე ტექსტი ხილული რჩება.",
  "Check each designer’s license before publishing.":
    "გამოქვეყნებამდე შეამოწმეთ დიზაინერის ლიცენზია.",
  "Legacy font: website text needs the original encoding.":
    "ძველი კოდირება: ვებსაიტის ტექსტს შესაბამისი კოდირება სჭირდება.",
  "Your next type story starts here.": "თქვენი შემდეგი ამბავი აქ იწყება.",
  "Add a font below to preview it and get your code.":
    "დაამატეთ შრიფტი ნიმუშისა და კოდის სანახავად.",
  "Remove font": "შრიფტის ამოშლა",
  "In use": "დიზაინში",
  Newspaper: "გაზეთი",
  Website: "ვებსაიტი",
  Banner: "ბანერი",
  Poster: "პოსტერი",
  "Try your own headline…": "საკუთარი სათაური…",
  "Sample headline": "სანიმუშო სათაური",
  "Typography preview": "ტიპოგრაფიული ნიმუში",
  Alphabet: "ანბანი",
  "Georgian pangram": "ქართული პანგრამა",
  Rustaveli: "რუსთაველი",
  "Everyday text": "ყოველდღიური",
  Numbers: "ციფრები",
  Custom: "საკუთარი",
  "Preview text preset": "სანიმუშო ტექსტის ტიპი",
  Explore: "ფონტები",
  Converter: "კონვერტერი",
  Embed: "ვებსაიტზე",
  Saved: "რჩეულები",
  Day: "დღე",
  Night: "ღამე",
  "Georgian type studio": "ქართული შრიფტების სტუდია",
  "THE GEORGIAN TYPE LIBRARY": "ქართული შრიფტების ბიბლიოთეკა",
  "A language.": "ერთი ენა.",
  "A thousand voices.": "ათასი ხმა.",
  "A language. A thousand voices.": "ერთი ენა. ათასი ხმა.",
  "Discover a new expression of Georgian.":
    "აღმოაჩინეთ ქართული დამწერლობის ახალი სახე.",
  Filters: "ფილტრები",
  "Reset all": "გასუფთავება",
  Encoding: "კოდირება",
  "Writing system": "დამწერლობა",
  Classification: "კატეგორია",
  Style: "სტილი",
  Designer: "დიზაინერი",
  "All styles": "ყველა სტილი",
  "All designers": "ყველა დიზაინერი",
  "Includes lari symbol ₾": "შეიცავს ლარის სიმბოლოს ₾",
  "Favorites stay on this device.": "რჩეულები ინახება ამ მოწყობილობაზე.",
  "893 downloadable fonts.": "893 ჩამოსატვირთი შრიფტი.",
  "Original categories from": "კატეგორიების წყარო:",
  "Search fonts, designers, or styles": "მოძებნეთ შრიფტი, დიზაინერი ან სტილი",
  "Type something Georgian…": "აკრიფეთ ტექსტი ქართულად…",
  "Featured first": "რჩეული შრიფტები",
  "Name A–Z": "სახელის მიხედვით",
  "Most characters": "სიმბოლოების რაოდენობით",
  "to make your mark": "თქვენი იდეებისთვის",
  Latin: "ლათინური",
  STD8: "სტანდარტული",
  Unicode: "უნიკოდი",
  Unknown: "უცნობი",
  "Khutsuri Mtavruli": "ხუცური მთავრული",
  "Khutsuri Nuskhuri": "ხუცური ნუსხური",
  "Mkhedruli Mtavruli": "მხედრული მთავრული",
  "Mkhedruli Nuskhuri": "მხედრული ნუსხური",
  Brush: "ფუნჯი",
  Calligraphy: "კალიგრაფიული",
  Decorative: "დეკორატიული",
  Gothic: "გოთიკური",
  Grotesque: "გროტესკული",
  Handwritten: "ხელნაწერი",
  Pixel: "პიქსელური",
  "Sans Serif": "უსერიფო",
  Serif: "სერიფიანი",
  Stencil: "შაბლონური",
  Typewriter: "საბეჭდი მანქანის",
  Western: "ვესტერნი",
  Regular: "ჩვეულებრივი",
  Bold: "მუქი",
  Italic: "დახრილი",
  "Bold Italic": "მუქი დახრილი",
  "Your collection": "თქვენი კოლექცია",
  "Good type.": "კარგი შრიფტი.",
  "Kept close.": "ყოველთვის ახლოს.",
  "Good type. Kept close.": "კარგი შრიფტი. ყოველთვის ახლოს.",
  "Your personal shortlist, ready for the next idea.":
    "თქვენი რჩეული შრიფტები შემდეგი იდეისთვის.",
  "Your next favorite is out there.": "იპოვეთ თქვენი შემდეგი რჩეული.",
  "Tap the heart on a font to keep it here.":
    "დააჭირეთ გულს შრიფტის შესანახად.",
  "Explore fonts": "დაათვალიერეთ შრიფტები",
  "No fonts match just yet.": "შრიფტები ვერ მოიძებნა.",
  "Try another search or clear a filter.":
    "შეცვალეთ ძიება ან გაასუფთავეთ ფილტრი.",
  "Clear filters": "ფილტრების გასუფთავება",
  "Compare fonts": "შედარება",
  "Saved to your collection": "დაემატა რჩეულებს",
  "Removed from saved fonts": "წაიშალა რჩეულებიდან",
  "FONT SPOTLIGHT": "შრიფტის შესახებ",
  "Download font": "შრიფტის ჩამოტვირთვა",
  Specimen: "ნიმუში",
  Glyphs: "სიმბოლოები",
  "Details & license": "დეტალები და ლიცენზია",
  "Unicode specimen": "უნიკოდის ნიმუში",
  "More styles in this family": "ამ ოჯახის სხვა სტილები",
  "Glyph coverage": "სიმბოლოები",
  Family: "ოჯახი",
  "Writing systems": "დამწერლობა",
  Format: "ფორმატი",
  "Keyboard layout": "კლავიატურის განლაგება",
  Version: "ვერსია",
  "Lari symbol": "ლარის სიმბოლო",
  Included: "შეიცავს",
  "Not listed": "არ არის მითითებული",
  Packs: "პაკეტები",
  None: "არცერთი",
  Characters: "სიმბოლოები",
  "License & attribution": "ლიცენზია და ავტორობა",
  "Font license": "შრიფტის ლიცენზია",
  "Original font page": "შრიფტის წყარო",
  "SIDE BY SIDE": "შედარება",
  "Find your perfect fit.": "იპოვეთ სასურველი შრიფტი.",
  "The same words. A different feeling.": "იგივე სიტყვები. სხვა განწყობა.",
  "WORDS WITHOUT BARRIERS": "სიტყვები ბარიერების გარეშე",
  "A new encoding.": "ახალი კოდირება.",
  "The same voice.": "იგივე ხმა.",
  "A new encoding. The same voice.": "ახალი კოდირება. იგივე ხმა.",
  "Move between Georgian Unicode, legacy fonts, and keyboard layouts.":
    "გადაიყვანეთ ტექსტი უნიკოდში, ძველ კოდირებებსა და კლავიატურის განლაგებებს შორის.",
  "Latin to Georgian": "ლათინურიდან ქართულზე",
  "Georgian to Latin": "ქართულიდან ლათინურზე",
  "Legacy to Unicode": "ძველი კოდირებიდან უნიკოდზე",
  "Mkhedruli to Mtavruli": "მხედრულიდან მთავრულზე",
  From: "საიდან",
  To: "სად",
  "Paste or type your text here…": "ჩასვით ან აკრიფეთ ტექსტი…",
  "Your converted text appears here…": "გადაყვანილი ტექსტი გამოჩნდება აქ…",
  "Select all": "ყველას მონიშვნა",
  Clear: "გასუფთავება",
  Swap: "გაცვლა",
  Keyboard: "კლავიატურა",
  "Keep layout": "უცვლელი განლაგება",
  "English to Russian": "ინგლისურიდან რუსულზე",
  "Russian to English": "რუსულიდან ინგლისურზე",
  "Save .txt": ".txt ფაილის შენახვა",
  "Copy result": "შედეგის კოპირება",
  "Latin / QWERTY": "ლათინური / QWERTY",
  "Georgian standard (STD8)": "ქართული სტანდარტული (STD8)",
  "Georgian Unicode — Mkhedruli": "ქართული უნიკოდი — მხედრული",
  "Georgian Unicode — Mtavruli": "ქართული უნიკოდი — მთავრული",
  "Georgian Unicode — Nuskhuri": "ქართული უნიკოდი — ნუსხური",
  "Georgian Unicode — Asomtavruli": "ქართული უნიკოდი — ასომთავრული",
  "Copied to clipboard": "ტექსტი დაკოპირებულია",
  "GEORGIAN TYPE, EVERYWHERE": "ქართული შრიფტი ყველგან",
  "Your website.": "თქვენი ვებსაიტი.",
  "Your type.": "თქვენი შრიფტი.",
  "Your website. Your type.": "თქვენი ვებსაიტი. თქვენი შრიფტი.",
  "Choose your fonts. Copy the code. Make it Georgian.":
    "აირჩიეთ შრიფტი, დააკოპირეთ კოდი და გამოიყენეთ ვებსაიტზე.",
  "1. Choose your fonts": "1. აირჩიეთ შრიფტები",
  "2. Add to your website": "2. დაამატეთ ვებსაიტზე",
  "3. APPLY THE FONT": "3. გამოიყენეთ შრიფტი",
  "Find a font or designer…": "მოძებნეთ შრიფტი ან დიზაინერი…",
  "Add font": "შრიფტის დამატება",
  "Your selected fonts will appear here.": "არჩეული შრიფტები გამოჩნდება აქ.",
  "HTML link": "HTML ბმული",
  "CSS @import": "CSS @import",
  "Place the stylesheet link inside your page’s <head>.":
    "ჩასვით სტილის ბმული თქვენი გვერდის <head> ელემენტში.",
  "Place @import at the beginning of your stylesheet.":
    "ჩასვით @import სტილის ფაილის დასაწყისში.",
  "Copy embed code": "ჩასმის კოდის კოპირება",
  "Copy CSS": "CSS-ის კოპირება",
  "Choose a font to generate your embed code.":
    "კოდის შესაქმნელად აირჩიეთ შრიფტი.",
  "Your font-family CSS will appear here.": "შრიფტის CSS გამოჩნდება აქ.",
  "Use on the web": "ვებსაიტზე გამოყენება",
  "Font added to your embed selection": "შრიფტი დაემატა ვებსაიტის ნაკრებს",
  "Preview mapping": "ნიმუშის კოდირება",
  "Raw input / no conversion": "საწყისი ტექსტი / უცვლელი",
  "Source download unavailable": "წყაროს ფაილი მიუწვდომელია",
  Unavailable: "მიუწვდომელი",
  "Fonts with restricted embedding flags are excluded. For every other font, confirm the designer’s web-use license before publishing.":
    "აკრძალული ჩაშენების ნიშნულის მქონე შრიფტები გამორიცხულია. სხვა შრიფტებისთვის გამოქვეყნებამდე გადაამოწმეთ ავტორის ვებგამოყენების ლიცენზია.",
  "Stylesheets use font-display: swap and load only your selected fonts. Legacy fonts need correctly encoded text; Unicode fonts are recommended for new websites.":
    "იტვირთება მხოლოდ არჩეული შრიფტები. ძველ შრიფტებს შესაბამისი კოდირების ტექსტი სჭირდება; ახალი ვებსაიტებისთვის რეკომენდებულია უნიკოდი.",
  "No explicit license text is embedded in this font. Check with the designer before commercial use or redistribution.":
    "ამ შრიფტში ლიცენზიის ტექსტი არ არის ჩაშენებული. კომერციულ გამოყენებამდე ან გავრცელებამდე დაუკავშირდით ავტორს.",
  "Common encodings": "ძირითადი კოდირებები",
  "Legacy & custom encodings": "ძველი და დამატებითი კოდირებები",
  "Close filters": "ფილტრების დახურვა",
  "Close font details": "დეტალების დახურვა",
  "Close comparison": "შედარების დახურვა",
  "Search fonts": "შრიფტების ძიება",
  "Toggle day and night mode": "დღისა და ღამის რეჟიმი",
  "Switch interface language": "ენის შეცვლა",
  "Font preview text": "შრიფტის სანიმუშო ტექსტი",
  "Preview font size": "შრიფტის ზომა",
  "Search embeddable fonts": "ვებშრიფტების ძიება",
  "Choose a font to embed": "აირჩიეთ ვებშრიფტი",
  "Text to convert": "გადასაყვანი ტექსტი",
  "Converted text": "გადაყვანილი ტექსტი",
};
